<div class="footerArea" [class]="(isHome)?'extended':''">
    @if (isHome) {
    <div class="wrapperMain">
        <div class="footer-info mt-20">
            <div class="column">
                <h3>Contact Us</h3>
                <ul>
                    <li class="doublespace"><a href="mailto:info@kilowant.com" aria-label="If you have any questions, please contact us by email.">info&#64;kilowant.com</a></li>
                    <li class="doublespace">401.487.1652</li>
                    <li class="doublespace">
                        Kilowant LLC
                        <br />
                        P.O. Box 299
                        <br />
                        Charlestown, RI 02813
                    </li>
                </ul>
            </div>
            <div class="column">
                <h3>Kilowant Links</h3>
                <ul>
                    <li><a routerLink="/user/kilowant-u" aria-label="Read more on Kilowant University's page for details on energy purchasing.">kilowant U</a></li>
                    <li><a routerLink="/our-story" aria-label="Read our story">Our Story</a></li>
                    <li><a routerLink="/faq" aria-label="Read out the frequently asked questions.">FAQ</a></li>
                    <li><a routerLink="/user/registration" aria-label="Fill out this simple form to sign up for kilowant and start saving on your energy bills.">Sign Up</a></li>
                    <li><a routerLink="/user/login" aria-label="Use this form to sign in to kilowant.">Sign In</a></li>
                    <li><a routerLink="/tou" aria-label="Read our terms of use.">Terms of Use</a></li>
                    <li><a routerLink="/disclaimer" aria-label="Read kilowant.com Transaction Application Disclaimer.">Disclaimer</a></li>
                    <li><a routerLink="/privacy-policy" aria-label="Read our privacy policy.">Privacy Policy</a></li>
                </ul>
            </div>
        </div>
        <div class="footer-info f13">
            <h3>About Kilowant</h3>
            kilowant lowers your electric bill by using AI to autonomously shop for low-priced electricity supply plans...saving you time and money. Our innovative AI-enabled "Nonstop Shop (TM)" technology searches for market opportunities 24/7 and sources discounted electricity price plans as an alternative to your utility and community energy supply rates. Participating third-party suppliers are state registered, PUC licensed, and utility approved. All price plan offers are fixed-rate and fixed-term, yielding guaranteed savings with no unauthorized renewals. kilowant is your trusted partner for a smarter, sustainable, more affordable energy solution, ensuring you save money without the hassle of extensive research or risk of poor market timing.
            <div class="text-center mt-10">
                <a class="facebook-link" href="https://www.facebook.com/kilowant/" aria-label="Visit our Facebook page to view our blog."></a>
                <a class="instagram-link" href="https://www.instagram.com/kilowant/" aria-label="Visit our Instagram page to view our blog."></a>
                <a class="linkedin-link" href="https://www.linkedin.com/company/kilowant/" aria-label="Visit our Linkedin page to view our blog."></a>
            </div>
        </div>
    </div>
    }
    <div class="footerIcon mt-10"></div>
    <div class="footer" (click)="gotoLogin()">Copyright &copy; 2022 - {{currentYear()}} kilowant, LLC</div>
</div>